import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import uploadIcon from "Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import backArrow from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-16px.svg";
import { withSnackbar } from "notistack";
import React from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import DynamicForm from "Component/DynamicForm";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class Questions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      identitytypeid: "",
      option1: false,
      option2: false,
      option3: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { identitytypeid } = this.state;
    return (
      <div
        className="fluid-container width100"
        style={{ background: "#f9f9f9" }}
      >
        <div className="display-flex">
          <p
            style={{
              color: "#010709",
              fontSize: 24,
              marginBottom: 32,
              fontWeight: "bold",
            }}
          >
            Screening questions
          </p>
          <p
            style={{
              color: "#010709",
              fontSize: 24,
              marginBottom: 32,
              fontWeight: "bold",
            }}
          >
            Step 3
          </p>
        </div>
        <Grid container className="margin-bottom-24">
          <Grid item xs={12} md={6} sm={12}>
            <p className="large-text-dark-secondary t-bold margin-bottom-16">
              Company and culture
            </p>
            <DynamicForm
              fields={textareainputconverter({
                value: this.state.workingProficiency,
                label: "What do you look for in a company’s work culture?",
                placeholder: "",
              })}
              onChange={(e) => this.handleChange("workingProficiency", e)}
            />
            <DynamicForm
              fields={textareainputconverter({
                value: this.state.workingProficiency,
                label: "Why did you choose to apply to our company?",
                placeholder: "",
              })}
              onChange={(e) => this.handleChange("workingProficiency", e)}
            />
            <p className="input-label">
              Which of the following do you best identify youself as?
            </p>
            <DynamicForm
              fields={radioinputconverter({
                value: identitytypeid == 1,
                label: "Introvert",
                labelclass: "margin-top-2",
                // disabled:
                //   this.state.check && this.state.check.editable
                //     ? postdata.fbppaidtypeid != 1
                //     : true,
              })}
              onChange={() => this.handleChange("identitytypeid", 1)}
            />
            <DynamicForm
              fields={radioinputconverter({
                value: identitytypeid == 2,
                label: "Ambivert",
                labelclass: "margin-top-2",
              })}
              onChange={() => this.handleChange("identitytypeid", 2)}
            />
            <DynamicForm
              fields={radioinputconverter({
                value: identitytypeid == 2,
                label: "Extrovert",
                labelclass: "margin-top-2",
              })}
              onChange={() => this.handleChange("identitytypeid", 3)}
            />
            <p className="large-text-dark-secondary t-bold margin-bottom-16">
              Functional and core
            </p>

            <p className="input-label">
              Which libraries are you comfortable using?
            </p>
            <DynamicForm
              fields={checkboxinputconverter({
                value: this.state.option1,
                placeholder: "",
                label: "ReactJS",
              })}
              onChange={(value) => {
                this.handleChange(value, "option1");
              }}
            />
            <DynamicForm
              fields={checkboxinputconverter({
                value: this.state.option2,
                placeholder: "",
                label: "AngularJS",
              })}
              onChange={(value) => {
                this.handleChange(value, "option2");
              }}
            />
            <DynamicForm
              fields={checkboxinputconverter({
                value: this.state.option3,
                placeholder: "",
                label: "Vue",
              })}
              onChange={(value) => {
                this.handleChange(value, "option3");
              }}
            />
            <DynamicForm
              fields={textareainputconverter({
                value: this.state.workingProficiency,
                label:
                  "Please explain briefly a project you worked on using one of the libraries selected above.",
                placeholder: "",
              })}
              onChange={(e) => this.handleChange("workingProficiency", e)}
            />
          </Grid>
        </Grid>
        <div className="margin-top-24">
          <div className="margin-bottom-16 floatleft">
            <span
              className="floatleft margin-right-16 cursor-pointer"
              // onClick={() => this.setState({ empform: null })}
            >
              <img src={backArrow}></img>
            </span>
            <span className="floatleft normal-dark-secondary t-bold">
              Document upload
            </span>
            <div className="clear-float"></div>
          </div>
          <div className="floatright">
            <Button
              className="btn btn-primary-md-blue"
              variant="contained"
              onClick={this.props.submit}
            >
              Submit application
            </Button>
          </div>
          <div className="clear-float"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Questions)));
